<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" query-api="inspectionDeliveryTaskQuery"
                                $_em-custom-vuex-mixin_vo="inspectionVo"
                                $_em-custom-vuex-mixin_filter="inspectionFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryDeliveryTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      query-api="inspectionDeliveryTaskQuery"
                                      withCustomRowActions
                                      $_em-custom-vuex-mixin_vo="inspectionVo"
                                      $_em-custom-vuex-mixin_filter="inspectionFilter"
                                      $_em-custom-vuex-mixin_entity="inspectionEntity"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="添加BOM"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openBomDialog()"
                                    >
                                    </em-button>
                                    <em-button type="check" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="发起质检"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        confirm-text="确认发起质检？"
                                        @click="createInspectionTask()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-undo-alt"
                                        :disabled="actionDisabled('select')"
                                        custom-label="退回转交"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        :busy="onComplete"
                                        @click="returnTasks()"
                                        confirm-text="确定退回选中的转交任务？"
                                    >
                                    </em-button>
                                    <!-- <em-button type="check" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="发起出门证申请"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        confirm-text="确认发起？"
                                        @click="createInspectionTask()"
                                    >
                                    </em-button> -->
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="添加BOM" :visible.sync="bomDialogVisible" :close-on-click-modal='false' append-to-body @close='clearBomData'>
            <el-form :inline="true" :model="filterForm" label-position="left" label-width="60px">
                <el-form-item label="描述">
                    <el-input v-model="filterForm.filterString"></el-input>
                </el-form-item>
                <el-form-item label="物料号">
                    <el-input v-model="filterForm.filterString2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="searchCriteriaIsEmpty" @click="searchBom">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="tree-bom-div">
                <el-tree ref="elBomTree" :data="treeData" :props="defaultProps" :load="loadNode" lazy show-checkbox @check-change="checkChange" node-key="id" empty-text="输入关键字搜索BOM">
                </el-tree>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="bomDialogVisible = false">取消</el-button>
                <!-- <el-button type="primary" @click="bomDialogVisible()" :disabled="noBomSelected()">添加</el-button> -->
                <el-button type="primary" @click="addBomToDeliveryTask()">添加</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-24 20:46:26

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesInventoryInspectionDeliveryTaskListView",
        mixins: [emCommonListMixin,emCommonGotoMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                bomDialogVisible: false,
                filterForm: {
                    filterString: '',
                    filterString2: '',
                },
                treeData: [],
                //定义element树的默认属性，children为子节点数组，longText为显示的名称，leaf标志是否为叶子节点
                defaultProps: {
                    children: "children",
                    label(data,node) {
                        return data.longText + ": " + data.component;
                    },
                    isLeaf: "leaf"
                },
                selectObj: {
                    checkedNode: {},
                    checkedId: []
                },
                onComplete:false,
            }
        },
        computed:{
            modelName(){
                return 'sithMesInventoryDeliveryTask'
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsInspectionVo"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsInspectionVo"].join(",");
            },
            searchCriteriaIsEmpty() {
                if(this.filterForm.filterString === '' && this.filterForm.filterString2 === '') {
                    return true;
                }
                return false;
            }
        },
        methods: {
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
                    , {deliveryTaskIdFilter: row.id}
                    , {deliveryTaskId: row.id}, false, {})
            },
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            openBomDialog() {
                this.bomDialogVisible = true;
            },
            clearBomData() {
                this.filterForm.filterString = '';
                this.filterForm.filterString2 = '';
                this.treeData = [];
            },
            searchBom() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findBomByConditions`;
                let obj = new Object();
                obj.longTextFilter = self.filterForm.filterString;
                obj.componentFilter = self.filterForm.filterString2;
                self.$_emApiMixin_post(url, obj)
                .then((response) => {
                    if(response.data instanceof Array) {
                        response.data.map(item => {
                        self.treeData.push(Object.assign({},item,{children:""}))
                    })
                    }
                })
            },
            //点击BOM树左侧三角时查询子BOM
            searchChildrenBoms(node,resolve) {
                let bomId = node.data.id;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findChildrenBomById?id=${bomId}`;
                this.$_emApiMixin_get(url, {})
                .then((response)=>{
                    if(response.length === 0) {
                        resolve([]);
                    } else {
                        resolve(response);
                    }

                })
            },
            //懒加载树，节点数据变动时调用
            loadNode(node, resolve) {
                if(node.level === 0) {
                    resolve(this.treeData);
                } else {
                    setTimeout(()=>{
                        this.searchChildrenBoms(node,resolve);
                    },500)
                }
            },
            //控制单选,先不用
            checkChange(data, checked) {
                // const index = this.selectObj.checkedId.indexOf(data.id);
                // if(index <0 && this.selectObj.checkedId.length === 1 && checked) {
                //     this.$refs.bomTree.setChecked(this.selectObj.checkedNode, false);
                //     this.selectObj.selectIds = [];
                //     this.selectObj.push(data.id);
                //     this.selectObj.checkedNode = data;
                // } else if(this.selectObj.checkedId.length === 0 && checked) {
                //     this.selectObj.checkedNode = data;
                //     this.selectObj.checkedId = [];
                //     this.selectObj.checkedId.push(data.id);
                // } else if(index >= 0 && this.selectObj.checkedId.length === 1 && !checked) {
                //     this.selectObj.checkedId = [];
                // }
                console.log("bom change");
            },
            addBomToDeliveryTask() {
                let self = this;
                //element树自带的getCheckedKeys方法获取选中BOM的ID
                let bomIds = this.$refs.elBomTree.getCheckedKeys().join(",");
                let taskId = this.selectIds;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/addBomToDeliveryTask?ids=${taskId}&bomIds=${bomIds}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "添加成功",
                            type: "success",
                            });
                            self.bomDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "添加失败",
                            type: "error",
                            });
                        }
                    })
            },
            createInspectionTask() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/createFinalInspectionTask?id=${self.checkedItems}`;
                this.$_emApiMixin_post(url, {})
                .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "发起质检任务成功",
                            duration:5000,
                            type: "success",
                            });
                            self.bomDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "发起质检任务失败",
                            duration:5000,
                            type: "error",
                            });
                        }
                    })
            },
            returnTasks() {
                this.onComplete = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/returnTasks?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "退回成功");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
            }
        },
        mounted() {
            if (this.$route.query.hasOwnProperty('id')) {
                    this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            }
            if (this.$route.query.hasOwnProperty('deliveryNo')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('deliveryNoFilter', this.$route.query.deliveryNo);
            }
            this.$refs.emListFilter.doQuery();
        },
    };
</script>

<style scoped>
.bom-tree {
    height: 285px;
}
.tree-bom-div {
    height: 285px;
    overflow: scroll;
}
.tree-bom-div ::v-deep .el-checkbox{
    width: 20px;
}
</style>
